import { createContext, useContext } from 'react'

export const AdvisorUserClientTableContext = createContext({
  editing: false
})

export const useAdvisorUserClientsActions = () => {
  return useContext(AdvisorUserClientTableContext)
}
